
// src/web/components/app.jsx

import React from 'react'
import AlertMessage from './alert-message.jsx'
import connect from '../../connects/app'
import { Layout } from 'react-toolbox/lib/layout'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import Checkbox from 'react-toolbox/lib/checkbox'
import ConfirmDialog from './confirm-dialog.jsx'
import appButtonTheme from './themes/app-button.css'

const DisableInvokeApp = 'gambaApp.disableInvokeApp'

class App extends React.Component {
  state = { oldApp: false, invokeApp: undefined }

  componentDidMount() {
    document.addEventListener('WebViewJavascriptBridgeReady', ()=> this.setState({ oldApp: true }))
    if (window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod)/)) {
      window.WVJBCallbacks = [()=> this.setState({ oldApp: true })];
      var WVJBIframe = document.createElement('iframe');
      WVJBIframe.style.display = 'none';
      WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
    }

    if (window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod|android)/) && !localStorage.getItem(DisableInvokeApp))
      this.setState({ invokeApp: true })
  }

  disableInvokeApp = ()=> {
    localStorage.setItem(DisableInvokeApp, 'TRUE')
    this.setState({ invokeApp: false })
  }

  render() {
    if (this.state.oldApp)
      return (
        <Dialog active={true}
          title="いますぐ、アプリを更新してください">
          <div style={{ marginBottom: '10px', color: 'black' }}>
            <b>gamba! のスマートフォンアプリは、性能向上と使い勝手改善のため
            <span style={{ color: 'red' }}>全面的にリニューアル</span>いたしました！</b>
          </div>
          <div>
            全面リニューアルされたスマートフォンアプリをお使いいただくには、
            下記リンクよりダウンロードしていただく必要があります。<br/>
            なお、現在お使いのバージョンのアプリは、今後、お使いいただくことができません。
            あしからず、ご了承ください。
          </div>
          <div style={{ margin: '20px 10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <a href="https://itunes.apple.com/jp/app/gamba-ri-bao-gong-younotameno/id1032574463?mt=8" target="_blank" rel="noopener noreferrer">
              <span className={appButtonTheme.itunes} />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.rikkeisoft.gamba" target="_blank" rel="noopener noreferrer">
              <span className={appButtonTheme.android} />
            </a>
          </div>
        </Dialog>
      )

    return (
      <Layout>
        <AlertMessage />
        {this.props.children}
        {this.state.invokeApp && <ConfirmDialog open={true}
          yesHref={`gamba://getgamba.com/${document.location.href.replace(/https?:\/\/[^\/]+\//, '').replace(/[#:]/g, '')}`}
          noHref={
            window.navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod)/) ?
              "https://itunes.apple.com/jp/app/gamba-ri-bao-gong-younotameno/id1032574463?mt=8" :
              "https://play.google.com/store/apps/details?id=com.rikkeisoft.gamba"
          }
          onNo={()=> this.setState({ deeplink: undefined })}
          yesLabel={this.props.t('label:アプリで開く')}
          noLabel={this.props.t('label:アプリをダウンロード')}
          description={
            <Checkbox label={this.props.t('label:アプリを使用しない')}
              onChange={this.disableInvokeApp} />
          }
          title={this.props.t('label:gambaアプリで開く')} />
        }
      </Layout>
    )
  }
}

export const RawApp = App
export default connect(App)



// WEBPACK FOOTER //
// ./src/web/components/app.jsx